module.exports = __webpack_public_path__ + "assets/img/time.d95f9d58.svg";